module.exports = __webpack_public_path__ + "img/male3.e321ef92.png";